export default {
    show: false,
    text: '操作异常',
    callback: '',           // 关闭回调(auto, close, cancel)
    cancelState: false,     // 是否可以主动关闭, 默认false
    timeOut: 2000           // true: 表示不关闭
};



// WEBPACK FOOTER //
// ./src/ui/toast/store/state.js